'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');
require('../buttons/ClearButton/ClearButton.js');
require('../buttons/SecondaryButton/SecondaryButton.js');
require('../buttons/AddAttachmentsButton/AddAttachmentsButton.js');
require('../buttons/BlueTextButton/BlueTextButton.js');
require('../buttons/BackButton/BackButton.js');
require('../buttons/BorderlessButton/BorderlessButton.js');
require('../buttons/ButtonAndStatus/ButtonAndStatus.js');
require('../buttons/ButtonGroup/ButtonGroup.js');
require('../buttons/DialogPrimaryButton/DialogPrimaryButton.js');
require('../buttons/DialogSecondaryButton/DialogSecondaryButton.js');
require('../buttons/DialogWarningButton/DialogWarningButton.js');
require('../buttons/FormButton/FormButton.js');
require('../buttons/IconButtonWithDropDown/IconButtonWithDropDown.js');
require('../buttons/PillButton/PillButton.js');
var PrimaryButton = require('../buttons/PrimaryButton/PrimaryButton.js');
require('../buttons/TwoToneButton/TwoToneButton.js');
require('../buttons/WarningButton/WarningButton.js');
require('../buttons/AvatarButtons/ButtonWithAvatar/ButtonWithAvatar.js');
require('../buttons/AvatarButtons/AvatarWithSubtitle/AvatarWithSubtitle.js');
require('../buttons/AvatarButtons/VerticalAvatar/VerticalAvatar.js');
var PropTypes = _interopDefault(require('prop-types'));
var ErrorIcon = _interopDefault(require('@material-ui/icons/Error'));
var yup = require('yup');
var formik = require('formik');

var useStyles = core.makeStyles(function () {
    return core.createStyles({
        wrapper: {
            display: 'flex',
            paddingTop: 5,
        },
        icon: {
            color: '#ed5a5a',
            fontSize: function (props) { return (props.size === 'large' ? 25 : 20); },
        },
        message: {
            color: '#ed5a5a',
            fontFamily: 'TTCommons',
            fontSize: function (props) { return (props.size === 'large' ? 20 : 15); },
            fontWeight: 400,
            lineHeight: 1.66,
            display: 'inline',
            marginLeft: 5,
            marginTop: '0 !important',
        },
    });
});
var ErrorMessageWithIcon = function (props) {
    var classes = useStyles(props);
    var message = props.message, customIcon = props.customIcon;
    return (React__default.createElement("div", { className: classes.wrapper },
        customIcon || React__default.createElement(ErrorIcon, { className: classes.icon }),
        React__default.createElement("p", { className: classes.message }, message)));
};
ErrorMessageWithIcon.propTypes = {
    message: PropTypes.string.isRequired,
    customIcon: PropTypes.element.isRequired,
};
var TextWrapper = styled__default(core.TextField)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  border-radius: 15px;\n  background-color: #ffffff;\n  box-shadow: 5px 5px rgba(60, 128, 209, 0.09);\n  margin-bottom: 15px;\n"], ["\n  border-radius: 15px;\n  background-color: #ffffff;\n  box-shadow: 5px 5px rgba(60, 128, 209, 0.09);\n  margin-bottom: 15px;\n"])));
var FlexWrapper = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n"])));
var TextLabel = styled__default.p(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  color: #12253f;\n  font-family: 'TTCommons';\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 23px;\n  margin-bottom: 8px;\n  margin-top: 8px;\n"], ["\n  color: #12253f;\n  font-family: 'TTCommons';\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 23px;\n  margin-bottom: 8px;\n  margin-top: 8px;\n"])));
var DEFAULT_REGEX = /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/])|(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/])|(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/])).{16,}/;
var DEFAULT_REGEX_ERROR = 'Password must have a minimum of 16 characters with at least 1 upper case, 1 numeric and 1 special character.';
// Component Definition
var PasswordWithValidation = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.pattern, pattern = _b === void 0 ? DEFAULT_REGEX : _b, _c = _a.patternError, patternError = _c === void 0 ? DEFAULT_REGEX_ERROR : _c, _d = _a.usernameOrEmail, usernameOrEmail = _d === void 0 ? '' : _d, _e = _a.existingPassword, existingPassword = _e === void 0 ? false : _e;
    var _f, _g, _h, _j;
    var escapeValueForRegex = function (value) {
        if (!value)
            return '';
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    var _k = formik.useFormik({
        // Initial Form Values
        initialValues: {
            password: '',
            currentPassword: '',
            confirmPassword: '',
        },
        // Event Handlers
        onSubmit: function (val) {
            onSubmit({
                password: val.password,
                currentPassword: val.currentPassword,
                confirmPassword: val.confirmPassword,
            });
        },
        // Validation Schema
        validationSchema: yup.object().shape(tslib.__assign(tslib.__assign(tslib.__assign({}, (existingPassword && {
            currentPassword: yup.string().required('Please enter your current password.'),
        })), (usernameOrEmail && {
            password: yup.string()
                .matches(pattern, patternError)
                .required('The passwords entered do not match.')
                .matches(new RegExp("^(?!.*" + escapeValueForRegex((_f = usernameOrEmail === null || usernameOrEmail === void 0 ? void 0 : usernameOrEmail.split('@')) === null || _f === void 0 ? void 0 : _f[0]) + ").*$", 'i'), 'Password cannot match username or email.')
                .matches(new RegExp("^(?!.*" + escapeValueForRegex((_g = usernameOrEmail === null || usernameOrEmail === void 0 ? void 0 : usernameOrEmail.split('@')) === null || _g === void 0 ? void 0 : _g[1]) + ").*$", 'i'), 'Password cannot match username or email.')
                .matches(new RegExp("^(?!.*" + escapeValueForRegex(usernameOrEmail) + ").*$", 'i'), 'Password cannot match username or email.'),
            confirmPassword: yup.string()
                .matches(pattern, patternError)
                .required('The passwords entered do not match.')
                .matches(new RegExp("^(?!.*" + escapeValueForRegex((_h = usernameOrEmail === null || usernameOrEmail === void 0 ? void 0 : usernameOrEmail.split('@')) === null || _h === void 0 ? void 0 : _h[0]) + ").*$", 'i'), 'Password cannot match username or email.')
                .matches(new RegExp("^(?!.*" + escapeValueForRegex((_j = usernameOrEmail === null || usernameOrEmail === void 0 ? void 0 : usernameOrEmail.split('@')) === null || _j === void 0 ? void 0 : _j[1]) + ").*$", 'i'), 'Password cannot match username or email.')
                .matches(new RegExp("^(?!.*" + escapeValueForRegex(usernameOrEmail) + ").*$", 'i'), 'Password cannot match username or email.')
                .oneOf([yup.ref('password')], 'The passwords entered do not match.'),
        })), (!usernameOrEmail && {
            password: yup.string()
                .matches(pattern, patternError)
                .required('The passwords entered do not match.'),
            confirmPassword: yup.string()
                .matches(pattern, patternError)
                .required('The passwords entered do not match.')
                .oneOf([yup.ref('password')], 'The passwords entered do not match.'),
        }))),
    }), values = _k.values, handleChange = _k.handleChange, touched = _k.touched, errors = _k.errors, handleBlur = _k.handleBlur, submitForm = _k.submitForm, isValid = _k.isValid;
    var _l = React__default.useState(''), confirmPasswordError = _l[0], setConfirmPasswordError = _l[1];
    var _m = React__default.useState(''), passwordError = _m[0], setPasswordError = _m[1];
    React__default.useEffect(function () {
        if (!!errors.confirmPassword && !!touched.confirmPassword) {
            setConfirmPasswordError(errors.confirmPassword);
        }
        else {
            setConfirmPasswordError('');
        }
        if (!!errors.password && !!touched.password) {
            setPasswordError(errors.password);
        }
        else {
            setPasswordError('');
        }
    }, [errors, touched]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("form", { autoComplete: 'off' },
            React__default.createElement(FlexWrapper, null,
                existingPassword && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(TextLabel, null, "Current Password"),
                    React__default.createElement(TextWrapper, { inputProps: { maxLength: 50, style: { fontSize: 20 } }, onChange: handleChange, name: 'currentPassword', placeholder: 'Current Password', value: values.currentPassword, type: 'password', label: null, variant: 'outlined', style: { borderBottom: '1px solid rgba(60,128,209,0.09)' }, onBlur: handleBlur, error: !!errors.currentPassword && !!touched.currentPassword }))),
                React__default.createElement(TextLabel, null, "Password"),
                React__default.createElement(TextWrapper, { inputProps: { maxLength: 50, style: { fontSize: 20 } }, onChange: handleChange, name: 'password', placeholder: 'Password', value: values.password, type: 'password', label: null, variant: 'outlined', style: { borderBottom: '1px solid rgba(60,128,209,0.09)' }, onBlur: handleBlur, error: !!errors.password && !!touched.password }),
                passwordError && React__default.createElement(ErrorMessageWithIcon, { message: passwordError }),
                React__default.createElement(TextLabel, null, "Confirm Password"),
                React__default.createElement(TextWrapper, { inputProps: { maxLength: 50, style: { fontSize: 20 } }, onChange: handleChange, name: 'confirmPassword', placeholder: 'Confirm Password', value: values.confirmPassword, type: 'password', label: null, variant: 'outlined', style: { borderBottom: '1px solid rgba(60,128,209,0.09)' }, onBlur: handleBlur, error: !!errors.confirmPassword && !!touched.confirmPassword }),
                confirmPasswordError && React__default.createElement(ErrorMessageWithIcon, { message: confirmPasswordError }),
                React__default.createElement(PrimaryButton, { onClick: submitForm, title: 'Set Password', disabled: touched && !isValid })))));
};
var templateObject_1, templateObject_2, templateObject_3;

module.exports = PasswordWithValidation;
